import React, { useCallback, useState } from "react";
import AddButton from "../buttons/AddButton";
import DictionaryModal from "./DictionaryModal";
import { useStoreActions, useStoreState } from "easy-peasy";
import Login from "../common/headers/Login";
export default function AddDictionary(props) {
  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  const handleSubmit = (evt) => {
    evt.preventDefault();
  };

  const [modal1, setModal1] = useState(false);
  const toggle1 = () => setModal1(!modal1);
  const isLogged = useStoreState((state) => state.chapter.isLogged);
  return (
    <div>
      <AddButton onClick={isLogged ? toggle : toggle1} />
      <Login modal={modal1} toggle={toggle1} />
      <DictionaryModal
        modal={modal}
        handleSubmit={handleSubmit}
        toggle={toggle}
        data={props.wordlist}
      />
    </div>
  );
}
